import languageService from '../../../../services/LanguageService'

function getEventTypeField(eventTypeId: string, field: 'description' | 'imageText'): string {
  const value = languageService.getTranslation('tags', eventTypeId, field, true)
  if (value?.trim()) return value

  // LanguageService reaches for the English map only when the tag is missing
  // from the reader's language altogether, not when just this field is. Without
  // this, a JA/ZH reader loses every value that hasn't been translated yet —
  // the same English fallback the blueprint glossary copy gets.
  const fallback: string | undefined = languageService.languageMaps?.fallback?.tags?.[eventTypeId]?.[field]
  return fallback?.trim() ? fallback : ''
}

/**
 * Analyst-written description of an event type — the same copy the Data
 * Glossary's Live Event Types tab shows, read from the language map that is
 * already loaded before the app renders, so no extra request.
 *
 * `forceCorrectField` is not optional here: without it LanguageService falls
 * back to the tag's `name` when it has no `description`, which would render an
 * event type's own title as its description.
 *
 * Returns plain text, unlike blueprint descriptions (rich HTML from the
 * blueprint glossary endpoint) — callers must render it as text.
 */
export function getEventTypeDescription(eventTypeId: string): string {
  return getEventTypeField(eventTypeId, 'description')
}

/**
 * Caption of an event type's example screenshot. Same fallback chain as the
 * description (reader's language, then English, then ''), and never the tag name.
 */
export function getEventTypeImageText(eventTypeId: string): string {
  return getEventTypeField(eventTypeId, 'imageText')
}
